module.exports = __webpack_public_path__ + "img/35.32bba3fc.png";